// extracted by mini-css-extract-plugin
export default {"shift":"shiftDrawer_shift__xORS3","submit-shift":"shiftDrawer_submit-shift__kbmsM"};